import { render } from "./RiskSelectionSection.vue?vue&type=template&id=062b6c40"
import script from "./RiskSelectionSection.vue?vue&type=script&lang=js"
export * from "./RiskSelectionSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__